import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const CasesClient = React.lazy(() => import("../screean/case/casesClient"));
export function casoCliente() {
  return (
    <Route
      path="/casos-cliente"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <CasesClient />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
